import * as React from 'react'

import { Container } from '.'
import { styled } from '../../../common/ui'
import { theme } from '../theme'

const FooterContainer = styled.div`
  padding: 25px 0;
`

const FooterText = styled.div`
  padding: 0;
  margin: 0;
  width: 50%;

  p {
    text-align: left;
    font-size: 14px;
    font-weight: normal;
    color: ${theme.colors.gray};
    padding: 0 15px 0 0;
    margin: 0;
  }
  @media all and (max-width: 800px) {
    width: 100%;
    text-align: center;
    p {
      text-align: center;
    }
  }
`

const FooterImage = styled.div`
  width: 50%;
  text-align: right;
  img {
    width: 100%;
    max-width: 492px;
  }
  @media all and (max-width: 800px) {
    padding: 25px 0;
    width: 100%;
    text-align: center;
  }
`
const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  @media all and (max-width: 800px) {
    flex-wrap: wrap;
  }
`

export class Footer extends React.Component<
  { text: React.ReactNode; image: string },
  {}
> {
  public render() {
    const { text, image } = this.props
    return (
      <FooterContainer>
        <Container>
          <InnerContainer>
            <FooterText>
              <p>{text}</p>
            </FooterText>
            <FooterImage>
              <img src={image} alt="Logotypy" />
            </FooterImage>
          </InnerContainer>
        </Container>
      </FooterContainer>
    )
  }
}
